import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'
import Moment from 'react-moment';
import VisIcon from '../../../images/submenu_open copy 6.png'
import NavigateIcon from '../../../images/submenu_open copy 5.png'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'
import WarningIcon from '../../../images/advarsel2.png'

class Eierforhold extends Component {
    state = {
        isOpened: false
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.antall == 1) this.setState({isOpened: true})
    }

    toggleEierforhold = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    navigateMatrikkelenhet = (event) => {
        event.stopPropagation()
        this.props.onMatrikkelObjectSelected({
            domainKlasse: "Matrikkelenhet",
            matrikkelenhet: this.props.eierforhold
        })
    }

    showMatrikkelenhet = (event) => {
        event.stopPropagation()
        this.props.onEvent({
            type: MatrikkelSearchEvents.ShowObject,
            data: {
                type: MatrikkelSearchEvents.ShowMatrikkelenhet,
                matrikkelenhet: this.props.eierforhold
            }
        })
    }

    render() {
        const { t } = this.props
        var eierforhold = this.props.eierforhold
        var matrikkelnummer = `${eierforhold.gardsnummer}/${eierforhold.bruksnummer}`;
        if (eierforhold.festenummer || eierforhold.seksjonsnummer) matrikkelnummer += `/${eierforhold.festenummer}/${eierforhold.seksjonsnummer}`;
        var andel = eierforhold.nevner > 0 ? ` - ${eierforhold.teller}/${eierforhold.nevner}` : "";
        var eierforholdKode = eierforhold.EierforholdKodeEiendeMatrikkelenhet || eierforhold.eierforholdKode;
        var rolle = eierforholdKode ? eierforholdKode.substr(0, eierforholdKode.indexOf(' ')) : "";
        var infoList = []
        if (eierforhold.utgatt) infoList.push(t('utgatt'))
        if (!eierforhold.harTeig) infoList.push(t('manglerteig'))

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleEierforhold}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{eierforhold.kommuneId}-{matrikkelnummer}, {rolle}{andel}</span>
                    { infoList.length > 0 &&
                    <div className="icon-image tooltip warning">
                        <img src={WarningIcon} />
                        <div className="tooltip-content">
                            {infoList.map((i, index) => { return (<div key={index}>{i}</div>) })}
                        </div>
                    </div> }
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                    <div className="icon-image right tooltip" onClick={this.navigateMatrikkelenhet}>
                        <img className="tool" src={NavigateIcon} />
                        <div className="tooltip-content">{t('naviger.matrikkelenhet', { domeneklasse: eierforhold.matrikkelenhetDomeneklasse.toLowerCase() })}</div>
                    </div>
                    { eierforhold.harTeig &&
                    <div className="icon-image right tooltip" onClick={this.showMatrikkelenhet}>
                        <img className="tool" src={VisIcon} />
                        <div className="tooltip-content">{t('vis.matrikkelenhet', { domeneklasse: eierforhold.matrikkelenhetDomeneklasse.toLowerCase() })}</div>
                    </div> }
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kommune')}</div>
                            <div className="value">{eierforhold.kommunenavn} ({eierforhold.kommuneId})</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('eiendom')}</div>
                            <div className="value">{matrikkelnummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('rolle')}</div>
                            <div className="value">{eierforhold.eierforholdKode}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('andel')}</div>
                            <div className="value">{eierforhold.teller}/{eierforhold.nevner}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('datofra')}</div>
                            <div className="value"><Moment local>{eierforhold.datoFra}</Moment></div>
                        </div>
                        <div className="column">
                            <div className="label">{t('andelsnummer')}</div>
                            <div className="value">{eierforhold.andelsnummer}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('tinglyst')}</div>
                            <div className="value">{eierforhold.tinglyst? "Ja" : "Nei"}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Eierforhold)